export const NEWS_ACTION_TYPES = {
  LOAD_NEWS: 'news/LOAD_NEWS',
  CREATE_NEWS: 'administration/CREATE_NEWS',
  EDIT_NEWS: 'administration/EDIT_NEWS',
  DELETE_NEWS: 'administration/DELETE_NEWS',
};

export function loadNews(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: NEWS_ACTION_TYPES.LOAD_NEWS,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export function createNews(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: NEWS_ACTION_TYPES.CREATE_NEWS,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export function editNews(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: NEWS_ACTION_TYPES.EDIT_NEWS,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export function deleteNews(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: NEWS_ACTION_TYPES.DELETE_NEWS,
        payload,
        resolve,
        reject,
      });
    });
  };
}
